import React from 'react'
import { Skeleton, Stack } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectCurrentStyle } from '../../../actions/discoverSlice'
import { BarChart } from '@mui/x-charts/BarChart';

const LeftItemStyle = {
    backgroundColor: '#ffffff',
    height: '100vh',
    padding: 0,
    textAlign: 'left',
    borderRadius: '16px',
    borderTop: '1px solid #08082F',
    overflow: 'hidden', 
    overflowY: 'scroll', 
    scrollbarWidth: 'none', 
    marginTop: { xs:0, lg: '0px' }
}

interface TracksStylesCardProps {
    discoverData: any
}

const TracksStylesCard = ({discoverData}: TracksStylesCardProps) => {
    const selectedStyle = useSelector(selectCurrentStyle)

    const fetchedStyles = discoverData?.chart_styles

    return <Stack sx={{...LeftItemStyle, ...{display: { xs: 'none', md: 'block', lg: 'block'}}}}>
    {
        discoverData && discoverData?.rankings?.length
            ? <BarChart
                sx={{p: 0}}
                hideLegend
                skipAnimation
                series={
                    [...discoverData.rankings.map((rank: any) => rank.track.apple_genre_names)]
                    .flat()
                    .reduce((acc, current) => { 
                        const x = acc.find((item: any) => item.toUpperCase() === current.toUpperCase())
                        if (!x) { 
                            return acc.concat([current]) 
                        } else { 
                            return acc 
                        }
                    }, [])
                    .filter((style: any) => !['Music', 'Musik', 'Musique', 'Música', 'ミュージック', fetchedStyles?.find((style: any) => style.apple_id === selectedStyle)?.apple_name].includes(style))
                    .sort((a: any,b: any) => [...discoverData.rankings.map((rank: any) => rank.track.apple_genre_names)].flat().filter(rstyle => rstyle === b).length - [...discoverData.rankings.map((rank: any) => rank.track.apple_genre_names)].flat().filter(rstyle => rstyle === a).length)
                    .map( (style: any) => [{ label: style, stack: 'style', data: [[...discoverData.rankings.map((rank: any) => rank.track.apple_genre_names)].flat().filter(rstyle => rstyle === style).length] }])
                    .flat()
                }
                xAxis={[{ data: [Intl.DateTimeFormat("fr-FR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                    }).format(new Date())] 
                }]}
                yAxis={[{ width: 1, disableLine: true, disableTicks: true }]}
                colors={[
                    '#080890', '#7C7CCF', '#0000FF', '#99FFFF', '#663933',
                    '#FFFF00', '#FF00FF', '#00FFFF', '#800000', '#008000',
                    '#000080', '#808000', '#800080', '#008080', '#C0C0C0',
                    '#808080', '#9999FF', '#FF9999', '#FFFFFF', '#99FF99', 
                    '#FF99FF', '#FFFF99', '#3366CC', '#33CC66', '#CC3366',
                    '#6633CC', '#CC6633', '#66CC33', '#33CCCC', '#CC33CC',
                    '#CCCC33', '#333399', '#339933', '#993333', '#993399',
                    '#399999', '#999939', '#663399', '#000000', '#396633', 
                    '#339966', '#966633', '#336699', '#993366', '#669933',
                    '#CC9999', '#99CC99', '#9999CC', '#66CCCC', '#CC66CC'
                ]}
                />
            : <Skeleton sx={{height: '100%'}}/>
    }
    </Stack>
}

export default TracksStylesCard
